import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import CustomDashboardCard from './CustomDashboardCard';
import CustomDashboardService from './service';
import { toast } from 'react-toastify';

const DashboardCustomIndex = () => {
  const [cards, setCards] = useState([]);

  const handleAddCard = () => {
    setCards((prev) => [
      ...prev,
      { id: Date.now(), config: null, isNew: true }
    ]);
  };

  useEffect(() => {
    const fetchConfigs = async () => {
      try {
        const res = await CustomDashboardService.getCustomDashboardConfig();
        if (res.data && Array.isArray(res.data.data)) {
          const configs = res.data.data.map((config) => ({
            id: config.id,
            config
          }));
          setCards(configs);
        }
      } catch (error) {
        console.error('Error fetching custom dashboard config:', error);
      }
    };
    fetchConfigs();
  }, []);
  const handleDeleteCard = async (id) => {
    try {
      const card = cards.find((c) => c.id === id);
      if (card && !card.isNew && id) {
        await CustomDashboardService.deleteConfig(id);
      }
      setCards((prev) => prev.filter((card) => card.id !== id));
      toast.success('Card excluído com sucesso!');
    } catch (error) {
      console.error('Error deleting custom dashboard config:', error);
      toast.error('Erro ao excluir card.');
    }
  };

  return (
    <Container
      fluid
      className="pt-4"
      style={{ position: 'relative', minHeight: '100vh' }}
    >
      {cards.map((card) => (
        <CustomDashboardCard
          key={card.id}
          config={card.config}
          onDelete={() => handleDeleteCard(card.id)}
          onSaved={(newId, configObj) => {
            setCards((prev) =>
              prev.map((c) =>
                c.id === card.id
                  ? { ...c, id: newId || c.id, config: configObj, isNew: false }
                  : c
              )
            );
          }}
        />
      ))}
      <button
        onClick={handleAddCard}
        style={{
          position: 'fixed',
          right: 24,
          bottom: 24,
          zIndex: 9999,
          background: '#28a745',
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
          borderRadius: '50%',
          width: 64,
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'box-shadow 0.2s'
        }}
        aria-label="Adicionar Card CustomDashboard"
      >
        <i
          className="fa fa-plus"
          aria-hidden="true"
          style={{ fontSize: 36, color: '#fff' }}
        ></i>
      </button>
    </Container>
  );
};

export default DashboardCustomIndex;
